import React from 'react';
import TierChip from './TierChip';

type TierKind = 'tier1' | 'tier6';

interface Props {
  kind: TierKind;
  label?: string;
}

const TierBadge: React.FC<Props> = ({ kind, label }) => (
  <TierChip riskTier={kind === 'tier1' ? 1 : 6} label={label} />
);

export default TierBadge;
